<template>
  <form @submit.prevent="submit">
    <Alert :message="errors" variant="danger" v-if="errors" />
    <div class="teams-set">
      <h4>Teams</h4>
      <div class="">
        Select which teams you would like this user to be a part of. You must select at least 1.
      </div>
      <div class="team-toggle" v-for="(team, t) in teams" :key="t">
        <Toggle @input="(checked) => checkTeam(checked, team.id)" :value="isMember(team)" />
        <div>{{ team.name }}</div>
      </div>
      <div
        class="text-danger mt-2"
        v-if="validation.fields.teams.errors.length && validation.fields.teams.dirty"
      >
        {{ validation.fields.teams.errors.join(". ") }}
      </div>
    </div>
    <div class="form-buttons">
      <Btn class="mr-2" variant="light" type="button" :disabled="loading" @click="cancel">
        {{ $t("global.cancel") }}
      </Btn>
      <Btn variant="primary" type="submit" :disabled="!isSubmittable()" :loading="loading">
        {{ $t("global.save") }}
      </Btn>
    </div>
  </form>
</template>

<script>
import { onMounted, reactive, ref } from "@vue/composition-api";
import Alert from "@/components/display/Alert";
import Btn from "@/components/display/Btn";
import store from "@/store";
import Toggle from "@/components/display/Toggle";
import useValidator from "@/utils/useValidator";
import { teamMemberEdit as validationRules } from "leatherman-js/utils/validations/forms";

export default {
  name: "TeamMemberEditForm",
  props: {
    teams: Array,
    member: Object,
  },
  components: {
    Alert,
    Btn,
    Toggle,
  },
  setup(props, { emit }) {
    const loading = ref(false);
    const errors = ref(null);
    const fieldSet = reactive({
      teams: props.member.teamIds,
    });

    const { validator } = useValidator();

    const checkTeam = (checked, teamId) => {
      if (checked && !fieldSet.teams.includes(teamId)) {
        fieldSet.teams.push(teamId);
      } else {
        fieldSet.teams = fieldSet.teams.filter((t) => t !== teamId);
      }
    };

    const validation = validator(
      fieldSet,
      validationRules,
      {},
      {
        teams: {
          length: "Must add at least 1 team.",
        },
      }
    );

    const cancel = () => emit("close");
    const isSubmittable = () => !loading.value && validation.errors.length === 0;
    const submit = () => {
      errors.value = null;

      validation
        .validate()
        .then(() => {
          loading.value = true;

          store
            .dispatch("auth/editUser", { id: props.member.id, roles: fieldSet.teams })
            .then(() => {
              store.dispatch("team/refreshMembers");
              emit("close");
            })
            .catch((e) => {
              errors.value = e;
              loading.value = false;
            });
        })
        .catch(() => {});
    };

    const isMember = (team) => props.member.teamIds.includes(team.id);

    onMounted(() => {
      console.log("mounted team member edit form");
    });

    return {
      isMember,
      fieldSet,
      errors,
      loading,
      submit,
      validation,
      cancel,
      isSubmittable,
      checkTeam,
    };
  },
};
</script>

<style lang="scss" scoped>
.plan-type {
  font-size: 1.5rem;
}
.plan-price {
  font-size: 2.5rem;
}
.form-buttons {
  text-align: right;
  padding-top: 2rem;
}

.teams-set {
  margin-top: 1rem;
  .team-toggle {
    display: flex;
    flex-direction: row;
    justify-content: flex-start;
    align-items: center;
    font-size: 1rem;
    margin: 1rem 0;
    padding-bottom: 1rem;
    border-width: 0;
    border-bottom-width: 1px;
    border-style: solid;
    border-color: rgba(0, 0, 0, 0.3);
  }
}
</style>
